import Axios from "axios";
import GenericApi from "Api";

/**
 * A class created to prepare data and perform http operations
 * related to a meta component.
 * @author Akira Kotsugai
 */
export default class MetaComponentApi {
  /**
   * it generates an url to export a meta component
   * @param {Number} metaComponentId - the meta component id
   */
  static getExportUrl = (metaComponentId, designJobId = false) => {
    let url = `${GenericApi.getBaseUrl()}/metacomponents/${metaComponentId}/export`;
    if (designJobId) {
      url += `?design_job_id=${designJobId}`;
    }
    return url;
  };

  /**
   * it makes a request to the export meta component endpoint
   * @param {Number} metaComponentId - the meta component id
   * @returns {Promise} the response
   */
  static export = (metaComponentId, designJobId = false) =>
    GenericApi.runApiCall(
      Axios({
        url: this.getExportUrl(metaComponentId, designJobId),
        method: "GET",
        responseType: "blob",
        headers: {
          "Content-Type": "application/x-zip-compressed"
        }
      }).then(resp => resp.data),
      "Failed to export meta component file."
    );
}
